// src/context/AtcAreaContext.ts
import { createContext, useContext } from "react";

import type { AtcProduct, AtcProductBase } from "@/types/atc";

export interface AtcAreaContextType {
  atcProducts: AtcProduct[];
  modalOpen: boolean;
  purchaseSource: string;
  promoCode?: string;
  showWelcomeKit?: boolean;
  oneTimePurchaseSource?: string;
  selectedProduct: AtcProduct;
  selectedOptionId: number;
  setAtcProducts?: (products: AtcProduct[] | AtcProductBase[]) => void;
  setPromoCode?: (p: string) => void;
  setPurchaseSource?: (p: string) => void;
  setShowWelcomeKit?: (p: boolean) => void;
  setOneTimePurchaseSource?: (p: string) => void;
  setSelectedProductId: (p: string) => void;
  setSelectedOptionId: (p: number) => void;
  setModalOpen: (p: boolean) => void;
}

export const AtcAreaContext = createContext<AtcAreaContextType | undefined>(undefined);

// Custom hook to consume the context
export function useAtcAreaContext() {
  const context = useContext(AtcAreaContext);
  return context; // Return undefined if no provider is found
}
